import { Center, Image, ImageProps } from "@mantine/core"
import { useDefaultAttachmentsApiForControllerRoute } from "../../../../attachment-api"

export function ResourceImage({
  attachmentId,
  resourceId,
  ...props
}: {
  attachmentId: number
  resourceId: number
} & Omit<ImageProps, "src">) {
  const attachmentApi = useDefaultAttachmentsApiForControllerRoute("resources")

  return (
    <Center w={"100%"}>
      <Image
        h={300}
        w={300}
        mah={"100%"}
        maw={"100%"}
        fit={"contain"}
        src={attachmentApi.getThumbnailUrl(attachmentId, resourceId, 300, true)}
        {...props}
      />
    </Center>
  )
}
